import { useEffect, useState } from 'react';

/** Tailwind `md`(768px) 미만 — 모바일 레이아웃으로 바꾸는 기준. CSS 의 `max-md:` 와 같은 선. */
export const MOBILE_QUERY = '(max-width: 767px)';

function matches(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_QUERY).matches;
}

/**
 * 구조가 달라져야 하는 화면(세 칸 → 한 칸, 표 → 목록)에서만 쓴다. 크기·간격만 바뀌면
 * Tailwind 반응형 클래스로 충분하다. matchMedia 가 없는 환경(jsdom)은 데스크톱으로 본다.
 */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(matches);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(MOBILE_QUERY);
    const update = () => setMobile(query.matches);
    update();
    query.addEventListener?.('change', update);
    return () => query.removeEventListener?.('change', update);
  }, []);
  return mobile;
}
